(function () {
  "use strict";

  var stage = document.querySelector("[data-cl-3d]");
  if (!stage) return;

  var scene = stage.querySelector("[data-cl-3d-scene]");
  if (!scene) return;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
  if (!finePointer.matches) return;

  var MAX_TILT = 15;
  var EASE = 0.11;

  var targetX = 0;
  var targetY = 0;
  var currentX = 0;
  var currentY = 0;
  var running = false;
  var inside = false;

  function frame() {
    currentX += (targetX - currentX) * EASE;
    currentY += (targetY - currentY) * EASE;

    scene.style.setProperty("--ry", currentX.toFixed(3) + "deg");
    scene.style.setProperty("--rx", currentY.toFixed(3) + "deg");

    var settled =
      Math.abs(targetX - currentX) < 0.01 && Math.abs(targetY - currentY) < 0.01;

    if (!inside && settled) {
      currentX = targetX;
      currentY = targetY;
      running = false;
      return;
    }

    requestAnimationFrame(frame);
  }

  function start() {
    if (!running) {
      running = true;
      requestAnimationFrame(frame);
    }
  }

  function onMove(event) {
    if (reduceMotion.matches) return;

    var rect = stage.getBoundingClientRect();
    var px = (event.clientX - rect.left) / rect.width - 0.5;
    var py = (event.clientY - rect.top) / rect.height - 0.5;

    px = Math.max(-0.5, Math.min(0.5, px));
    py = Math.max(-0.5, Math.min(0.5, py));

    targetX = px * MAX_TILT * 2;
    targetY = -py * MAX_TILT * 2;
    start();
  }

  stage.addEventListener("pointerenter", function () {
    inside = true;
  });

  stage.addEventListener("pointermove", onMove);

  stage.addEventListener("pointerleave", function () {
    inside = false;
    targetX = 0;
    targetY = 0;
    start();
  });

  reduceMotion.addEventListener("change", function () {
    if (reduceMotion.matches) {
      inside = false;
      targetX = 0;
      targetY = 0;
      start();
    }
  });
})();
